var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4901 57.6808C25.4728 57.6808 13.2979 45.5072 13.2979 30.4898C13.2979 15.4719 25.4728 3.29787 40.4901 3.29787C55.5069 3.29787 67.6808 15.4719 67.6808 30.4898C67.6808 45.5072 55.5069 57.6808 40.4901 57.6808ZM11 30.4894C11 46.7758 24.2033 59.9787 40.4896 59.9787C56.7755 59.9787 69.9787 46.7758 69.9787 30.4894C69.9787 14.2021 56.7755 1 40.4896 1C24.2033 1 11 14.2021 11 30.4894Z",
    fill: "#F57F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1703 46.5748C43.1703 48.055 41.9699 49.2553 40.4894 49.2553C39.009 49.2553 37.8086 48.055 37.8086 46.5748C37.8086 45.0938 39.009 43.8936 40.4894 43.8936C41.9699 43.8936 43.1703 45.0938 43.1703 46.5748Z",
    fill: "#F57F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 40C39.675 40 39 39.259 39 38.3533V15.6462C39 14.741 39.675 14 40.5 14C41.325 14 42 14.741 42 15.6462V38.3533C42 39.259 41.325 40 40.5 40Z",
    fill: "#F57F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.ccb0b6c21a2358d6031505a8ce05c3eb.svg";
export { ForwardRef as ReactComponent };